module.exports = __webpack_public_path__ + "static/media/Logotipo-SAPTalent-blanco.6f1ff435.svg";